import { API_URLs } from "../../../utilities/API_URLs";
import { Http } from "../../../utilities/axios/http";
import {
  CreateReleaseOrderPayload,
  RemovalType,
} from "../core/_model.releaseOrder";

export class ReleaseOrderService {
  static getReleaseOrderList = async (
    params?: any,
    removalType?: RemovalType
  ) => {
    try {
      return await Http.get(API_URLs.exitNote.exitNoteUrl, {
        ...params,
        ...(removalType ? { removalType } : {}),
      });
    } catch (error) {
      return error;
    }
  };

  static getReleaseOrderById = async (id: number | string) => {
    try {
      return await Http.get(`${API_URLs.exitNote.exitNoteUrl}/${id}`);
    } catch (error) {
      return error;
    }
  };

  /**
   * Removals of the customer made on the given day and not yet on an exit note.
   * "customer" is the numeric id, "date" is YYYY-MM-DD.
   */
  static getPendingRemovals = async (params: {
    customer: string | number;
    date: string;
    removalType: RemovalType;
    booking?: string | number;
  }) => {
    try {
      return await Http.get(API_URLs.exitNote.pendingRemovalsUrl, params);
    } catch (error) {
      return error;
    }
  };

  static createReleaseOrder = async (data: CreateReleaseOrderPayload) => {
    try {
      return await Http.post(API_URLs.exitNote.exitNoteUrl, data);
    } catch (error) {
      return error;
    }
  };

  /**
   * PATCH /exit_notes/{id}/cancel: keeps the note for traceability and releases
   * its removals. The backend requires a reason (Assert\NotBlank).
   */
  static cancelReleaseOrder = async (
    id: number | string,
    cancelReason: string
  ) => {
    try {
      return await Http.patchCustom(
        API_URLs.exitNote.exitNoteCancelUrl.replace("{id}", String(id)),
        { cancelReason }
      );
    } catch (error) {
      return error;
    }
  };
}
